import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */
export default function ReportItemAllAttendees({
  item,
  isOdd,
  type,
  allColumns = [],
  groupedHeaders = [],
}) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div
        className={styles.ibo}
        style={{
          fontWeight: type === "total" ? "bold" : "normal",
        }}
      >
        {item.IBO}
      </div>
      <div className={styles.iboALastName}>{item.iboALastName}</div>
      <div className={styles.iboAFirstName}>{item.iboAFirstName}</div>
      <div className={styles.iboBLastName}>{item.iboBLastName}</div>
      <div className={styles.iboBFirstName}>{item.iboBFirstName}</div>
      <div className={styles.pin}>{item.pin}</div>
      <div className={styles.diamond}>{item.diamond}</div>
      <div className={styles.attending}>{item.attending}</div>
      <div className={styles.email}>{item.email}</div>
      <div className={styles.phone}>{item.phone}</div>
      <div className={styles.topicsId}>{item.topicsId}</div>

      {allColumns.map((col, index, arr) => {
        const colCount = arr.length;
        const colWidth = 25 / colCount;

        // Use total value for total row
        const value =
          type === "total" ? item.columns?.[col.id] : col.getValue(item);

        // Determine if this column is the first in its group
        const isFirstInGroup = groupedHeaders.some(
          (group) => group.columns[0].id === col.id
        );

        return (
          <div
            key={`${col.id}-${index}`}
            className={index % 2 !== 0 ? styles.col : styles.oddCol}
            style={{
              width: `${colWidth}%`,
              textAlign: "center",
              borderLeft: isFirstInGroup ? "1px solid #000" : "none", // add left border for first in group
            }}
          >
            {value === 0 ? "" : value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemAllAttendees.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
};
